import { api } from './client';

import type { Campaign, CampaignContext, CampaignCreation } from '@/types/campaign';

export const fakeCampaign = {
  schema_version: "1.0.0",
    campaign_version: "3.0.0",
    created_at: "2025-01-01T00:00:00+00:00",
    updated_at: "2025-01-01T00:00:00+00:00",
    organization_id: "018ed32a-cb88-7483-bd6a-08c5a7708ddf",
    id: "8d9740ed-56ac-4f1f-856f-df9d81f16c52",
    campaign: {
      parent_workspace_id: "a6c6df1e-6d44-47e9-9904-741254eb4ea0", // compatible with nested folders/workspaces
      internal_name: "Yuzu - Paris",
      headline: "Recrutement d'un manager confirmé",
      tagline: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip. Duis aute irure dolor in reprehenderit.",
      job_title: "Manager",
      locale: "fr-FR",
      force_locale: true,
    },
    branding: {
      banner_image_id: "019ae525-8490-798e-b33c-f3051a532a52",
      background_image_id: "019ae525-c4ca-7708-be3b-d6878a678eb8",
      text_color: "#FFFFFF", // #FFFFFF or #000000 only ?
      highlight_color: "#16A4A5",
    },
    assessment: {
      environment: "planet_station",
      modules: ["adaptability", "self_efficacy", "active_listening",
        "empathy", "time_management", "stress_management", 
        "motivation", "decision_making", "planning", "leadership",
        "problem_solving", "learning_strategy", "social_desirability"
      ],
      weighting: "neutral",// in case of neutral : "weighting": "neutral"
    },
    surveys: {
      satisfaction: false,
      demographic: true,
    },
    documents: {
      certification: {
        send_to_talent: false
      },
      report: {
        send_to_talent: true,
        format: "complete"
      }
    },
    public_invite_id: "abcdefgh-1234-5678-a1b2-987654321yz",
    archived: false,
    auto_activate: false,
}

export const campaignsApi = {
  getAll: async (organisationId: string, spaceId: string, isOnboarded: boolean): Promise<Campaign[]> => {
    if (isOnboarded) {
      return [fakeCampaign as Campaign];
    }

    const { data } = await api.get(`/companies/${organisationId}/workspaces/${spaceId}/campaigns`);
    return data.campaigns;
  },

  get: async (campaignId: string, isOnboarded: boolean): Promise<Campaign> => {
    if (isOnboarded) {
      return fakeCampaign as Campaign;
    }

    const { data } = await api.get(`/api/v1/campaigns/${campaignId}`);
    return data;
  },

  getArchivedCampaigns: async (organizationId: string): Promise<{entries: { campaign: Campaign, total_participants: number, total_evaluated_participants: number }[] }> => {
    const { data } = await api.get(`/companies/${organizationId}/archived-campaigns`);
    return data;
  },

  add: async (organizationId: string, newCampaign: CampaignCreation): Promise<Campaign> => {
    try {
      const { data } = await api.post(`/api/v1/campaigns`, newCampaign, { headers: { "Content-Type": "application/json" } });
      return data;
    } catch (error) {
      throw error;
    }
  },

  edit: async (context: CampaignContext, campaign: Partial<Campaign>, auto_activate?: boolean) => {
    try {
      let params = auto_activate === null || auto_activate === undefined ? null : { params: { auto_activate: auto_activate } };
      const { data } = await api.patch(`/api/v1/campaigns/${context.campaignId}`, campaign, params);
      return data;
    } catch (error) {
      throw error;
    }
  },

  archive: async (organisationId: string, spaceId: string, campaignId: string): Promise<{ key: string, code: number }> => {
    try {
      const { data } = await api.delete(`/companies/${organisationId}/workspaces/${spaceId}/campaigns/${campaignId}`);
      return data;
    } catch (error) {
      throw error;
    }
  },

  restore: async (organisationId: string, campaignId: string, destinationSpaceId: string) => {
    try {
      const { data } = await api.put(`/companies/${organisationId}/campaigns/${campaignId}/restore`, { workspace_id: destinationSpaceId });
      return data;
    } catch (error) {
      throw error;
    }
  },

  toggleInvitation: async (context: CampaignContext, enabled: boolean) => {
    try {
      const { data } = await api.put(`/companies/${context.organisationId}/workspaces/${context.spaceId}/campaigns/${context.campaignId}/invitation`, { enabled });
      return data;
    } catch (error) {
      throw error;
    }
  },
}